
export const mapKeyedGetters = (map, key = 'uid') => {
    map = Object.assign({}, map);

    Object.entries(map).forEach(([name, getter]) => {
        map[name] = function() {
            return this.$store.getters[getter](this[key]);
        };
    })

    return map;
};

